"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.problemSchema = void 0;
exports.problemSchema = {
    type: ['object', 'null'],
    required: [],
    properties: {
        field: {
            type: ['string', 'null'],
            errorMessage: 'should be a string or null',
            default: '',
        },
        index: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
            default: 0,
        },
        value: {
            type: ['string', 'integer', 'null'],
            errorMessage: 'should be a string, integer or null',
            default: '',
        },
        code: {
            type: ['string', 'null'],
            errorMessage: 'should be a string or null',
            default: '',
        },
        type: {
            type: ['string', 'null'],
            errorMessage: 'should be a string or null',
            default: '',
        },
        infoName: {
            type: ['string', 'null'],
            errorMessage: 'should be a string or null',
            default: '',
        },
        infoValue: {
            type: ['string', 'null'],
            errorMessage: 'should be a string or null',
            default: '',
        },
    },
};
exports.default = exports.problemSchema;
